import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';
import Block, { LOCATIONS } from '@components/common/block';
import Dropdown from '@components/common/dropdown';
import ScrollBlock from '@components/common/scroll-block';
import testUiData from '../../../constants/test.json';

const TestKeys = Object.keys(testUiData.testOptions);
const TEST_NAMES = Object.keys(testUiData.testOptions).map(key => ({
  title: testUiData.testOptions[key],
}));
const INIT_TEST_IDX = TestKeys.length - 1;

class PickTestBlock extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onChange(INIT_TEST_IDX);
  }

  onChange(idx) {
    this.props.onChange(TestKeys[idx]);
  }

  render() {
    const props = this.props;

    return (
      <Block
        location={LOCATIONS.TOP}
        header='1. Pick a Test:'
        className={`${styles.block} ${props.short ? styles.blockShort : ''}`}>
        <Dropdown
          onChange={this.onChange}
          className={styles.dropdown}
          value={TestKeys.indexOf(props.value)}
          config={{ header: '', items: TEST_NAMES }}
        />
        <ScrollBlock className={styles.scrollBlock}>
          {testUiData['testDescriptions'][props.value]}
        </ScrollBlock>
      </Block>
    );
  }
}

PickTestBlock.defaultProps = {
  short: false,
};

PickTestBlock.propTypes = {
  value: PropTypes.string.isRequired,
  short: PropTypes.bool,
};

export default PickTestBlock;
